import { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import Button from "../../components/Button/Button";
import Skeleton from "react-loading-skeleton";
import {
  getDailyCheckInRuleSetting,
  updateDailyCheckInRuleSetting,
} from "../../store/ducks/dailyCheckIn/actions";
import { getDropDown } from "../../store/ducks/memberGroup/actions";
import NumberInput from "../../components/Input/NumberInput/NumberInput";
import Swal from "sweetalert2";
import Select2 from "../../components/Input/Select2/Select2";

/** the client will only render these game codes no matter what the server returns */
const gameCodeOptions = [
  {
      "label": "vs20olympgold",
      "value": "vs20olympgold"
  },
  {
      "label": "vs20sugarrushx",
      "value": "vs20sugarrushx"
  },
  {
      "label": "vswayslions",
      "value": "vswayslions"
  },
  {
      "label": "vsways5lions2",
      "value": "vsways5lions2"
  },
  {
      "label": "vswayswbounty",
      "value": "vswayswbounty"
  },
  {
      "label": "vs20olympx",
      "value": "vs20olympx"
  },
  {
      "label": "vswayspowzeus",
      "value": "vswayspowzeus"
  },
  {
      "label": "vswaysasiatrzn",
      "value": "vswaysasiatrzn"
  },
  {
      "label": "vswaysrabbits",
      "value": "vswaysrabbits"
  },
  {
      "label": "vswayswildbrst",
      "value": "vswayswildbrst"
  },
  {
      "label": "vs20dhsuper",
      "value": "vs20dhsuper"
  },
  {
      "label": "vswaysbandit",
      "value": "vswaysbandit"
  },
  {
      "label": "vs25pandagold",
      "value": "vs25pandagold"
  },
  {
      "label": "vs20sugarrush",
      "value": "vs20sugarrush"
  },
  {
      "label": "vswaysmltchmgw",
      "value": "vswaysmltchmgw"
  },
  {
      "label": "vswaysdogs",
      "value": "vswaysdogs"
  },
  {
      "label": "vs20fruitswx",
      "value": "vs20fruitswx"
  },
  {
      "label": "vswaysanime",
      "value": "vswaysanime"
  },
  {
      "label": "vs10gbseries",
      "value": "vs10gbseries"
  },
  {
      "label": "vs25sleepdrag",
      "value": "vs25sleepdrag"
  },
  {
      "label": "vs20jjjack",
      "value": "vs20jjjack"
  },
  {
      "label": "vswaysresurich",
      "value": "vswaysresurich"
  },
  {
      "label": "vswaysbufking",
      "value": "vswaysbufking"
  },
  {
      "label": "vs20olympgate",
      "value": "vs20olympgate"
  },
  {
      "label": "vswayscashsurg",
      "value": "vswayscashsurg"
  },
  {
      "label": "vs10bbbnz1000",
      "value": "vs10bbbnz1000"
  },
  {
      "label": "vs20starlightx",
      "value": "vs20starlightx"
  },
  {
      "label": "vs20fruitsw",
      "value": "vs20fruitsw"
  },
  {
      "label": "vswaysmahwin2",
      "value": "vswaysmahwin2"
  },
  {
      "label": "vs20starlight",
      "value": "vs20starlight"
  },
  {
      "label": "vs20gatotx",
      "value": "vs20gatotx"
  },
  {
      "label": "vs15godsofwar",
      "value": "vs15godsofwar"
  },
  {
      "label": "vs20olympxmas",
      "value": "vs20olympxmas"
  },
  {
      "label": "vs20procountx",
      "value": "vs20procountx"
  },
  {
      "label": "vs40wildwest",
      "value": "vs40wildwest"
  },
  {
      "label": "vs20tweethouse",
      "value": "vs20tweethouse"
  },
  {
      "label": "vs20pbonanza",
      "value": "vs20pbonanza"
  },
  {
      "label": "vs20sbxmas",
      "value": "vs20sbxmas"
  },
  {
      "label": "vswaysmegareel",
      "value": "vswaysmegareel"
  },
  {
      "label": "vswaysrhino",
      "value": "vswaysrhino"
  },
  {
      "label": "vs20doghouse",
      "value": "vs20doghouse"
  },
  {
      "label": "vs20saiman",
      "value": "vs20saiman"
  },
  {
      "label": "vs5joker",
      "value": "vs5joker"
  },
  {
      "label": "vs12tropicana",
      "value": "vs12tropicana"
  },
  {
      "label": "vs20amuleteg",
      "value": "vs20amuleteg"
  },
  {
      "label": "vswayshammthor",
      "value": "vswayshammthor"
  },
  {
      "label": "vs15seoultrain",
      "value": "vs15seoultrain"
  },
  {
      "label": "vs20rujakbnz",
      "value": "vs20rujakbnz"
  },
  {
      "label": "vswaysrockblst",
      "value": "vswaysrockblst"
  },
  {
      "label": "vs20portals",
      "value": "vs20portals"
  },
  {
      "label": "vs20rockvegas",
      "value": "vs20rockvegas"
  },
  {
      "label": "vs25pandatemple",
      "value": "vs25pandatemple"
  },
  {
      "label": "vs12bbb",
      "value": "vs12bbb"
  },
  {
      "label": "vs20bonzgold",
      "value": "vs20bonzgold"
  },
  {
      "label": "vs15samurai4",
      "value": "vs15samurai4"
  },
  {
      "label": "vs10txbigbass",
      "value": "vs10txbigbass"
  },
  {
      "label": "vswayswwriches",
      "value": "vswayswwriches"
  },
  {
      "label": "vs5aztecgems",
      "value": "vs5aztecgems"
  },
  {
      "label": "vs25checaishen",
      "value": "vs25checaishen"
  },
  {
      "label": "vs20mustanggld2",
      "value": "vs20mustanggld2"
  },
  {
      "label": "vswaysmadame",
      "value": "vswaysmadame"
  },
  {
      "label": "vs20sugrux",
      "value": "vs20sugrux"
  },
  {
      "label": "vs25goldparty",
      "value": "vs25goldparty"
  },
  {
      "label": "vs20muertos",
      "value": "vs20muertos"
  },
  {
      "label": "vs20xmascarol",
      "value": "vs20xmascarol"
  },
  {
      "label": "vs20procount",
      "value": "vs20procount"
  },
  {
      "label": "vswayspizza",
      "value": "vswayspizza"
  },
  {
      "label": "vs20cleocatra",
      "value": "vs20cleocatra"
  },
  {
      "label": "vs20farmfest",
      "value": "vs20farmfest"
  },
  {
      "label": "vs10bbhas",
      "value": "vs10bbhas"
  },
  {
      "label": "vs20gatotgates",
      "value": "vs20gatotgates"
  },
  {
      "label": "vs1024mjwinbns",
      "value": "vs1024mjwinbns"
  },
  {
      "label": "vs10floatdrg",
      "value": "vs10floatdrg"
  },
  {
      "label": "vswaystonypzz",
      "value": "vswaystonypzz"
  },
  {
      "label": "vs10fisheye",
      "value": "vs10fisheye"
  },
  {
      "label": "vswaysluckyfish",
      "value": "vswaysluckyfish"
  },
  {
      "label": "vs4096bufking",
      "value": "vs4096bufking"
  },
  {
      "label": "vswaysaztecking",
      "value": "vswaysaztecking"
  },
  {
      "label": "vs12bbbxmas",
      "value": "vs12bbbxmas"
  },
  {
      "label": "vs25hotfiesta",
      "value": "vs25hotfiesta"
  },
  {
      "label": "vs10fdrasbf",
      "value": "vs10fdrasbf"
  },
  {
      "label": "vs20ninjapower",
      "value": "vs20ninjapower"
  },
  {
      "label": "vs20mammoth",
      "value": "vs20mammoth"
  },
  {
      "label": "vs20framazon",
      "value": "vs20framazon"
  },
  {
      "label": "vs10returndead",
      "value": "vs10returndead"
  },
  {
      "label": "vswaysstampede",
      "value": "vswaysstampede"
  },
  {
      "label": "vs10bbbonanza",
      "value": "vs10bbbonanza"
  },
  {
      "label": "vs20sugarnudge",
      "value": "vs20sugarnudge"
  },
  {
      "label": "vs20fruitparty",
      "value": "vs20fruitparty"
  },
  {
      "label": "vsways5lionsr",
      "value": "vsways5lionsr"
  },
  {
      "label": "vs20bnnzdice",
      "value": "vs20bnnzdice"
  },
  {
      "label": "vs5t8goldfp",
      "value": "vs5t8goldfp"
  },
  {
      "label": "vs20alieninv",
      "value": "vs20alieninv"
  },
  {
      "label": "vswaysargonts",
      "value": "vswaysargonts"
  },
  {
      "label": "vs10bbbbrnd",
      "value": "vs10bbbbrnd"
  },
  {
      "label": "vs10bbrrp",
      "value": "vs10bbrrp"
  },
  {
      "label": "vs10chillihmr",
      "value": "vs10chillihmr"
  },
  {
      "label": "vs12trpcnhour",
      "value": "vs12trpcnhour"
  },
  {
      "label": "vs5tdragresk",
      "value": "vs5tdragresk"
  },
  {
      "label": "vs10fingerlfs",
      "value": "vs10fingerlfs"
  },
  {
      "label": "vswaysaztecgm",
      "value": "vswaysaztecgm"
  },
  {
      "label": "vs20gemfirefor",
      "value": "vs20gemfirefor"
  },
  {
      "label": "vs9gemtrio",
      "value": "vs9gemtrio"
  },
  {
      "label": "vs25goldpartya",
      "value": "vs25goldpartya"
  },
  {
      "label": "vs20popbottles",
      "value": "vs20popbottles"
  },
  {
      "label": "vs5luckyphnly",
      "value": "vs5luckyphnly"
  },
  {
      "label": "vs1mjokfp",
      "value": "vs1mjokfp"
  },
  {
      "label": "vswaysmjwl",
      "value": "vswaysmjwl"
  },
  {
      "label": "vs1dragon888",
      "value": "vs1dragon888"
  },
  {
      "label": "vs10spellmastr",
      "value": "vs10spellmastr"
  },
  {
      "label": "vswayssw",
      "value": "vswayssw"
  },
  {
      "label": "vs20swbonsup",
      "value": "vs20swbonsup"
  },
  {
      "label": "vs10diamondrgh",
      "value": "vs10diamondrgh"
  },
  {
      "label": "vswaysvlcgds",
      "value": "vswaysvlcgds"
  },
  {
      "label": "vs20bigmass",
      "value": "vs20bigmass"
  },
  {
      "label": "vs25quadwolf",
      "value": "vs25quadwolf"
  },
  {
      "label": "vs10piggybank",
      "value": "vs10piggybank"
  },
  {
      "label": "vswayspompmr2",
      "value": "vswayspompmr2"
  },
  {
      "label": "vs10bhallbnza",
      "value": "vs10bhallbnza"
  },
  {
      "label": "vs243lionsgold",
      "value": "vs243lionsgold"
  },
  {
      "label": "vs25holiday",
      "value": "vs25holiday"
  },
  {
      "label": "vs10bbdoubled",
      "value": "vs10bbdoubled"
  },
  {
      "label": "vswayssamurai",
      "value": "vswayssamurai"
  },
  {
      "label": "vs20olympdice",
      "value": "vs20olympdice"
  },
  {
      "label": "vs10bxmasbnza",
      "value": "vs10bxmasbnza"
  },
  {
      "label": "vs20candvil",
      "value": "vs20candvil"
  },
  {
      "label": "vs25copsrobbers",
      "value": "vs25copsrobbers"
  },
  {
      "label": "vswaysrsm",
      "value": "vswaysrsm"
  },
  {
      "label": "vs10bbfloats",
      "value": "vs10bbfloats"
  },
  {
      "label": "vswayswildwest",
      "value": "vswayswildwest"
  },
  {
      "label": "vs20doghouse2",
      "value": "vs20doghouse2"
  },
  {
      "label": "vs20candybltz2",
      "value": "vs20candybltz2"
  },
  {
      "label": "vs15fghtmultlv",
      "value": "vs15fghtmultlv"
  },
  {
      "label": "vs20wildparty",
      "value": "vs20wildparty"
  },
  {
      "label": "vswaysfrywld",
      "value": "vswaysfrywld"
  },
  {
      "label": "vs20minerush",
      "value": "vs20minerush"
  },
  {
      "label": "vs12scode",
      "value": "vs12scode"
  },
  {
      "label": "vs25luckwildpb",
      "value": "vs25luckwildpb"
  },
  {
      "label": "vs20fatbook",
      "value": "vs20fatbook"
  },
  {
      "label": "vs1024mahjwins",
      "value": "vs1024mahjwins"
  },
  {
      "label": "vs10bblotgl",
      "value": "vs10bblotgl"
  },
  {
      "label": "vs12bgrbspl",
      "value": "vs12bgrbspl"
  },
  {
      "label": "vs20mochimon",
      "value": "vs20mochimon"
  },
  {
      "label": "vs20fortbon",
      "value": "vs20fortbon"
  },
  {
      "label": "vs20schristmas",
      "value": "vs20schristmas"
  },
  {
      "label": "vswaysbrickhos",
      "value": "vswaysbrickhos"
  },
  {
      "label": "vs20dhcluster2",
      "value": "vs20dhcluster2"
  },
  {
      "label": "vs20doghousemh",
      "value": "vs20doghousemh"
  },
  {
      "label": "vs50fatfrogs",
      "value": "vs50fatfrogs"
  },
  {
      "label": "vs5luckyt1kly",
      "value": "vs5luckyt1kly"
  },
  {
      "label": "vswayscheist",
      "value": "vswayscheist"
  },
  {
      "label": "vs20pistols",
      "value": "vs20pistols"
  },
  {
      "label": "vswaysgoldcol",
      "value": "vswaysgoldcol"
  },
  {
      "label": "vs20goldclust",
      "value": "vs20goldclust"
  },
  {
      "label": "vs10egyptcls",
      "value": "vs10egyptcls"
  },
  {
      "label": "vs20asgard",
      "value": "vs20asgard"
  },
  {
      "label": "vswayslofhero",
      "value": "vswayslofhero"
  },
  {
      "label": "vs10bookfallen",
      "value": "vs10bookfallen"
  },
  {
      "label": "vswayswildgang",
      "value": "vswayswildgang"
  },
  {
      "label": "vs10bbrttr",
      "value": "vs10bbrttr"
  },
  {
      "label": "vswayslight",
      "value": "vswayslight"
  },
  {
      "label": "vs243mwarrior",
      "value": "vs243mwarrior"
  },
  {
      "label": "vs10bbkir",
      "value": "vs10bbkir"
  },
  {
      "label": "vswayszombcarn",
      "value": "vswayszombcarn"
  },
  {
      "label": "vs20stickywild",
      "value": "vs20stickywild"
  },
  {
      "label": "vs40pirate",
      "value": "vs40pirate"
  },
  {
      "label": "vs10fruity2",
      "value": "vs10fruity2"
  },
  {
      "label": "vs20olympgrace",
      "value": "vs20olympgrace"
  },
  {
      "label": "vs5triple8gold",
      "value": "vs5triple8gold"
  },
  {
      "label": "vs5luckytigly",
      "value": "vs5luckytigly"
  },
  {
      "label": "vs20forge",
      "value": "vs20forge"
  },
  {
      "label": "vs20clustwild",
      "value": "vs20clustwild"
  },
  {
      "label": "vswaysmonkey",
      "value": "vswaysmonkey"
  },
  {
      "label": "vs20dugems",
      "value": "vs20dugems"
  },
  {
      "label": "vs20mkrush",
      "value": "vs20mkrush"
  },
  {
      "label": "vs20lightblitz",
      "value": "vs20lightblitz"
  },
  {
      "label": "vs20goldfever",
      "value": "vs20goldfever"
  },
  {
      "label": "vs10tictac",
      "value": "vs10tictac"
  },
  {
      "label": "vs20sugarcoins",
      "value": "vs20sugarcoins"
  },
  {
      "label": "vs10firestrike",
      "value": "vs10firestrike"
  },
  {
      "label": "vs20rhinoluxe",
      "value": "vs20rhinoluxe"
  },
  {
      "label": "vswayskrakenmw",
      "value": "vswayskrakenmw"
  },
  {
      "label": "vs10eyestorm",
      "value": "vs10eyestorm"
  },
  {
      "label": "vs7776aztec",
      "value": "vs7776aztec"
  },
  {
      "label": "vswaysxjuicy",
      "value": "vswaysxjuicy"
  },
  {
      "label": "vswaysbkingasc",
      "value": "vswaysbkingasc"
  },
  {
      "label": "vs20octobeer",
      "value": "vs20octobeer"
  },
  {
      "label": "vswayssevenc",
      "value": "vswayssevenc"
  },
  {
      "label": "vs20heartcleo",
      "value": "vs20heartcleo"
  },
  {
      "label": "vs20dhdice",
      "value": "vs20dhdice"
  },
  {
      "label": "vs10bbsplxmas",
      "value": "vs10bbsplxmas"
  },
  {
      "label": "vswaysfuryodin",
      "value": "vswaysfuryodin"
  },
  {
      "label": "vs10fortnpig",
      "value": "vs10fortnpig"
  },
  {
      "label": "vswaysaztec",
      "value": "vswaysaztec"
  },
  {
      "label": "vs20terrorv",
      "value": "vs20terrorv"
  },
  {
      "label": "vs10fortnhsly",
      "value": "vs10fortnhsly"
  },
  {
      "label": "vs20midas2",
      "value": "vs20midas2"
  },
  {
      "label": "vs40cosmiccash",
      "value": "vs40cosmiccash"
  },
  {
      "label": "vs9aztecgemsdx",
      "value": "vs9aztecgemsdx"
  },
  {
      "label": "vs20gembondx",
      "value": "vs20gembondx"
  },
  {
      "label": "vswayswwjoker",
      "value": "vswayswwjoker"
  },
  {
      "label": "vs5super7",
      "value": "vs5super7"
  },
  {
      "label": "vswayscharms",
      "value": "vswayscharms"
  },
  {
      "label": "vs5bb3reeler",
      "value": "vs5bb3reeler"
  },
  {
      "label": "vs20aztecgates",
      "value": "vs20aztecgates"
  },
  {
      "label": "vs20candyblitz",
      "value": "vs20candyblitz"
  },
  {
      "label": "vs5ultrab",
      "value": "vs5ultrab"
  },
  {
      "label": "vs20laughluck",
      "value": "vs20laughluck"
  },
  {
      "label": "vs5magicdoor",
      "value": "vs5magicdoor"
  },
  {
      "label": "vs10bbfmission",
      "value": "vs10bbfmission"
  },
  {
      "label": "vs20santawonder",
      "value": "vs20santawonder"
  },
  {
      "label": "vs20excalibur",
      "value": "vs20excalibur"
  },
  {
      "label": "vs20hburnhs",
      "value": "vs20hburnhs"
  },
  {
      "label": "vs20midas",
      "value": "vs20midas"
  },
  {
      "label": "vs10cowgold",
      "value": "vs10cowgold"
  },
  {
      "label": "vs20dhcluster",
      "value": "vs20dhcluster"
  },
  {
      "label": "vs4096magician",
      "value": "vs4096magician"
  },
  {
      "label": "vs10bhallbnza2",
      "value": "vs10bhallbnza2"
  },
  {
      "label": "vs10bbbrlact",
      "value": "vs10bbbrlact"
  },
  {
      "label": "vs5luckymly",
      "value": "vs5luckymly"
  },
  {
      "label": "vs1dragon8",
      "value": "vs1dragon8"
  },
  {
      "label": "vs10bbextreme",
      "value": "vs10bbextreme"
  },
  {
      "label": "vswaysbufstamp",
      "value": "vswaysbufstamp"
  },
  {
      "label": "vswayscryscav",
      "value": "vswayscryscav"
  },
  {
      "label": "vs10powerlines",
      "value": "vs10powerlines"
  },
  {
      "label": "vswaysyumyum",
      "value": "vswaysyumyum"
  },
  {
      "label": "vs20cbrhst",
      "value": "vs20cbrhst"
  },
  {
      "label": "vs10fdsnake",
      "value": "vs10fdsnake"
  },
  {
      "label": "vs243lions",
      "value": "vs243lions"
  },
  {
      "label": "vs25scarabqueen",
      "value": "vs25scarabqueen"
  },
  {
      "label": "vs20fparty2",
      "value": "vs20fparty2"
  },
  {
      "label": "vs5ultra",
      "value": "vs5ultra"
  },
  {
      "label": "vs20rhino",
      "value": "vs20rhino"
  },
  {
      "label": "vs20phoenixf",
      "value": "vs20phoenixf"
  },
  {
      "label": "vs20drgbless",
      "value": "vs20drgbless"
  },
  {
      "label": "vswaysfltdrg",
      "value": "vswaysfltdrg"
  },
  {
      "label": "vs5wfrog",
      "value": "vs5wfrog"
  },
  {
      "label": "vswaysultrcoin",
      "value": "vswaysultrcoin"
  },
  {
      "label": "vswayssavlgnd",
      "value": "vswayssavlgnd"
  },
  {
      "label": "vs20porbs",
      "value": "vs20porbs"
  },
  {
      "label": "vs432congocash",
      "value": "vs432congocash"
  },
  {
      "label": "vs20cjcluster",
      "value": "vs20cjcluster"
  },
  {
      "label": "vswaysmegwghts",
      "value": "vswaysmegwghts"
  },
  {
      "label": "vs25rlbank",
      "value": "vs25rlbank"
  },
  {
      "label": "vs1024gmayhem",
      "value": "vs1024gmayhem"
  },
  {
      "label": "vs10bbxext",
      "value": "vs10bbxext"
  },
  {
      "label": "vs576treasures",
      "value": "vs576treasures"
  },
  {
      "label": "vs10spiritadv",
      "value": "vs10spiritadv"
  },
  {
      "label": "vswaysstrlght",
      "value": "vswaysstrlght"
  },
  {
      "label": "vs20bigdawgs",
      "value": "vs20bigdawgs"
  },
  {
      "label": "vs4096robber",
      "value": "vs4096robber"
  },
  {
      "label": "vs25aztecking",
      "value": "vs25aztecking"
  },
  {
      "label": "vs10dgold88",
      "value": "vs10dgold88"
  },
  {
      "label": "vs20superlanche",
      "value": "vs20superlanche"
  },
  {
      "label": "vs20trsbox",
      "value": "vs20trsbox"
  },
  {
      "label": "vs20eightdragons",
      "value": "vs20eightdragons"
  },
  {
      "label": "vs9ridelightng",
      "value": "vs9ridelightng"
  },
  {
      "label": "vs20bchprty",
      "value": "vs20bchprty"
  },
  {
      "label": "vs10forwildly",
      "value": "vs10forwildly"
  },
  {
      "label": "vs20fourmc",
      "value": "vs20fourmc"
  },
  {
      "label": "vs40infwild",
      "value": "vs40infwild"
  },
  {
      "label": "vs20mahjxbnz",
      "value": "vs20mahjxbnz"
  },
  {
      "label": "vs5jokerjc",
      "value": "vs5jokerjc"
  },
  {
      "label": "vswaysmodfr",
      "value": "vswaysmodfr"
  },
  {
      "label": "vs243queenie",
      "value": "vs243queenie"
  },
  {
      "label": "vs20rainbowrsh",
      "value": "vs20rainbowrsh"
  },
  {
      "label": "vs40spartaking",
      "value": "vs40spartaking"
  },
  {
      "label": "vs25chilli",
      "value": "vs25chilli"
  },
  {
      "label": "vs20leprechaun",
      "value": "vs20leprechaun"
  },
  {
      "label": "vs5himalaw",
      "value": "vs5himalaw"
  },
  {
      "label": "vswaysbblitz",
      "value": "vswaysbblitz"
  },
  {
      "label": "vs10emotiwins",
      "value": "vs10emotiwins"
  },
  {
      "label": "vswaysloki",
      "value": "vswaysloki"
  },
  {
      "label": "vs10bbbnz",
      "value": "vs10bbbnz"
  },
  {
      "label": "vswaysconcoll",
      "value": "vswaysconcoll"
  },
  {
      "label": "vs10firestrike2",
      "value": "vs10firestrike2"
  },
  {
      "label": "vs50safariking",
      "value": "vs50safariking"
  },
  {
      "label": "vs25wildspells",
      "value": "vs25wildspells"
  },
  {
      "label": "vs25rio",
      "value": "vs25rio"
  },
  {
      "label": "vs25mustang",
      "value": "vs25mustang"
  },
  {
      "label": "vs20trswild2",
      "value": "vs20trswild2"
  },
  {
      "label": "vswayselements",
      "value": "vswayselements"
  },
  {
      "label": "vswaysmfreya",
      "value": "vswaysmfreya"
  },
  {
      "label": "vs10gizagods",
      "value": "vs10gizagods"
  },
  {
      "label": "vswaysbbhas",
      "value": "vswaysbbhas"
  },
  {
      "label": "vs25btygold",
      "value": "vs25btygold"
  },
  {
      "label": "vs25kfruit",
      "value": "vs25kfruit"
  },
  {
      "label": "vs20bison",
      "value": "vs20bison"
  },
  {
      "label": "vs50jucier",
      "value": "vs50jucier"
  },
  {
      "label": "vs20kraken",
      "value": "vs20kraken"
  },
  {
      "label": "vs20plsmcannon",
      "value": "vs20plsmcannon"
  },
  {
      "label": "vswaysfirewmw",
      "value": "vswaysfirewmw"
  },
  {
      "label": "vs25pyramid",
      "value": "vs25pyramid"
  },
  {
      "label": "vs15diamond",
      "value": "vs15diamond"
  },
  {
      "label": "vs1024fortune",
      "value": "vs1024fortune"
  },
  {
      "label": "vs10trail",
      "value": "vs10trail"
  },
  {
      "label": "vswaysfltdrgny",
      "value": "vswaysfltdrgny"
  },
  {
      "label": "vs1024mahjpanda",
      "value": "vs1024mahjpanda"
  },
  {
      "label": "vs20emptybank",
      "value": "vs20emptybank"
  },
  {
      "label": "vswaysbbb",
      "value": "vswaysbbb"
  },
  {
      "label": "vs1tigers",
      "value": "vs1tigers"
  },
  {
      "label": "vs20gravity",
      "value": "vs20gravity"
  },
  {
      "label": "vs243dancingpar",
      "value": "vs243dancingpar"
  },
  {
      "label": "vs20kraken2",
      "value": "vs20kraken2"
  },
  {
      "label": "vswaysmegahays",
      "value": "vswaysmegahays"
  },
  {
      "label": "vswaysmoneyman",
      "value": "vswaysmoneyman"
  },
  {
      "label": "vs20splmystery",
      "value": "vs20splmystery"
  },
  {
      "label": "vs5luckydogly",
      "value": "vs5luckydogly"
  },
  {
      "label": "vs1024lionsd",
      "value": "vs1024lionsd"
  },
  {
      "label": "vs5drhs",
      "value": "vs5drhs"
  },
  {
      "label": "vs10fangfree",
      "value": "vs10fangfree"
  },
  {
      "label": "vs20clustcol",
      "value": "vs20clustcol"
  },
  {
      "label": "vs50juicyfr",
      "value": "vs50juicyfr"
  },
  {
      "label": "vswayspearls",
      "value": "vswayspearls"
  },
  {
      "label": "vs20trswild3",
      "value": "vs20trswild3"
  },
  {
      "label": "vs25mmouse",
      "value": "vs25mmouse"
  },
  {
      "label": "vs40wanderw",
      "value": "vs40wanderw"
  },
  {
      "label": "vs243fortune",
      "value": "vs243fortune"
  },
  {
      "label": "vs20gatotfury",
      "value": "vs20gatotfury"
  },
  {
      "label": "vswayschilheat",
      "value": "vswayschilheat"
  },
  {
      "label": "vs50mightra",
      "value": "vs50mightra"
  },
  {
      "label": "vs1fortunetree",
      "value": "vs1fortunetree"
  },
  {
      "label": "vs25wildies",
      "value": "vs25wildies"
  },
  {
      "label": "vs20mesmult",
      "value": "vs20mesmult"
  },
  {
      "label": "vs20jewelparty",
      "value": "vs20jewelparty"
  },
  {
      "label": "vs243empcaishen",
      "value": "vs243empcaishen"
  },
  {
      "label": "vs20drtgold",
      "value": "vs20drtgold"
  },
  {
      "label": "vs243chargebull",
      "value": "vs243chargebull"
  },
  {
      "label": "vswaysfreezet",
      "value": "vswaysfreezet"
  },
  {
      "label": "vs10nudgeit",
      "value": "vs10nudgeit"
  },
  {
      "label": "vswayswerewolf",
      "value": "vswayswerewolf"
  },
  {
      "label": "vswayswest",
      "value": "vswayswest"
  },
  {
      "label": "vs5jokerdice",
      "value": "vs5jokerdice"
  },
  {
      "label": "vs40wildrun",
      "value": "vs40wildrun"
  },
  {
      "label": "vswayscashconv",
      "value": "vswayscashconv"
  },
  {
      "label": "vs25peking",
      "value": "vs25peking"
  },
  {
      "label": "vs576hokkwolf",
      "value": "vs576hokkwolf"
  },
  {
      "label": "vs25archer",
      "value": "vs25archer"
  },
  {
      "label": "vs20wolfie",
      "value": "vs20wolfie"
  },
  {
      "label": "vs20mergedwndw",
      "value": "vs20mergedwndw"
  },
  {
      "label": "vs10fireice",
      "value": "vs10fireice"
  },
  {
      "label": "vs10booklight",
      "value": "vs10booklight"
  },
  {
      "label": "vs243caishien",
      "value": "vs243caishien"
  },
  {
      "label": "vs20superx",
      "value": "vs20superx"
  },
  {
      "label": "vswaystut",
      "value": "vswaystut"
  },
  {
      "label": "vs20clspwrndg",
      "value": "vs20clspwrndg"
  },
  {
      "label": "vs1masterjoker",
      "value": "vs1masterjoker"
  },
  {
      "label": "vs243goldfor",
      "value": "vs243goldfor"
  },
  {
      "label": "vs20bermuda",
      "value": "vs20bermuda"
  },
  {
      "label": "vs1money",
      "value": "vs1money"
  },
  {
      "label": "vs10coffee",
      "value": "vs10coffee"
  },
  {
      "label": "vs10tut",
      "value": "vs10tut"
  },
  {
      "label": "vs20multiup",
      "value": "vs20multiup"
  },
  {
      "label": "vs25ultwolgol",
      "value": "vs25ultwolgol"
  },
  {
      "label": "vswaysbook",
      "value": "vswaysbook"
  },
  {
      "label": "vs1600drago",
      "value": "vs1600drago"
  },
  {
      "label": "vs20stickysymbol",
      "value": "vs20stickysymbol"
  },
  {
      "label": "vs40bigjuan",
      "value": "vs40bigjuan"
  },
  {
      "label": "vs10amm",
      "value": "vs10amm"
  },
  {
      "label": "vs9piggybank",
      "value": "vs9piggybank"
  },
  {
      "label": "vs243fdragon",
      "value": "vs243fdragon"
  },
  {
      "label": "vs10bblpop",
      "value": "vs10bblpop"
  },
  {
      "label": "vs10frontrun",
      "value": "vs10frontrun"
  },
  {
      "label": "vs20chickdrop",
      "value": "vs20chickdrop"
  },
  {
      "label": "vs10luckcharm",
      "value": "vs10luckcharm"
  },
  {
      "label": "vs25bkofkngdm",
      "value": "vs25bkofkngdm"
  },
  {
      "label": "vs5jellyc",
      "value": "vs5jellyc"
  },
  {
      "label": "vs10wildtut",
      "value": "vs10wildtut"
  },
  {
      "label": "vs20sparta",
      "value": "vs20sparta"
  },
  {
      "label": "vs10fonzofff",
      "value": "vs10fonzofff"
  },
  {
      "label": "vs7fire88",
      "value": "vs7fire88"
  },
  {
      "label": "vswaysexpandng",
      "value": "vswaysexpandng"
  },
  {
      "label": "vs25bomb",
      "value": "vs25bomb"
  },
  {
      "label": "vs20crankit",
      "value": "vs20crankit"
  },
  {
      "label": "vs5littlegem",
      "value": "vs5littlegem"
  },
  {
      "label": "vs20clustext",
      "value": "vs20clustext"
  },
  {
      "label": "vs10dkinghp",
      "value": "vs10dkinghp"
  },
  {
      "label": "vs20maskgame",
      "value": "vs20maskgame"
  },
  {
      "label": "vs20bblitz",
      "value": "vs20bblitz"
  },
  {
      "label": "vswaysbewaretd",
      "value": "vswaysbewaretd"
  },
  {
      "label": "vs25gldox",
      "value": "vs25gldox"
  },
  {
      "label": "vs40rainbowr",
      "value": "vs40rainbowr"
  },
  {
      "label": "vs25badge",
      "value": "vs25badge"
  },
  {
      "label": "vs20ultim5",
      "value": "vs20ultim5"
  },
  {
      "label": "vs9chen",
      "value": "vs9chen"
  },
  {
      "label": "vs20mparty",
      "value": "vs20mparty"
  },
  {
      "label": "vs10strawberry",
      "value": "vs10strawberry"
  },
  {
      "label": "vs243fortseren",
      "value": "vs243fortseren"
  },
  {
      "label": "vs20swordofares",
      "value": "vs20swordofares"
  },
  {
      "label": "vs20nilefort",
      "value": "vs20nilefort"
  },
  {
      "label": "vs25wolfgold",
      "value": "vs25wolfgold"
  },
  {
      "label": "vs20powerwild",
      "value": "vs20powerwild"
  },
  {
      "label": "vs40stckwldlvl",
      "value": "vs40stckwldlvl"
  },
  {
      "label": "vs10noodles",
      "value": "vs10noodles"
  },
  {
      "label": "vs9outlaw",
      "value": "vs9outlaw"
  },
  {
      "label": "vs1024moonsh",
      "value": "vs1024moonsh"
  },
  {
      "label": "vs20medusast",
      "value": "vs20medusast"
  },
  {
      "label": "vs20yotdk",
      "value": "vs20yotdk"
  },
  {
      "label": "vswaysmorient",
      "value": "vswaysmorient"
  },
  {
      "label": "vs25asgard",
      "value": "vs25asgard"
  },
  {
      "label": "vs20magicpot",
      "value": "vs20magicpot"
  },
  {
      "label": "vs25tigeryear",
      "value": "vs25tigeryear"
  },
  {
      "label": "vswayshive",
      "value": "vswayshive"
  },
  {
      "label": "vs10runes",
      "value": "vs10runes"
  },
  {
      "label": "vs9hotroll",
      "value": "vs9hotroll"
  },
  {
      "label": "vs10madame",
      "value": "vs10madame"
  },
  {
      "label": "vswaysjapan",
      "value": "vswaysjapan"
  },
  {
      "label": "vs40cleoeye",
      "value": "vs40cleoeye"
  },
  {
      "label": "vs50aladdin",
      "value": "vs50aladdin"
  },
  {
      "label": "vs10gdchalleng",
      "value": "vs10gdchalleng"
  },
  {
      "label": "vswaysstrwild",
      "value": "vswaysstrwild"
  },
  {
      "label": "vs5jjwild",
      "value": "vs5jjwild"
  },
  {
      "label": "vs25vegas",
      "value": "vs25vegas"
  },
  {
      "label": "vs20shootstars",
      "value": "vs20shootstars"
  },
  {
      "label": "vs10bookoftut",
      "value": "vs10bookoftut"
  },
  {
      "label": "vswayscongcash",
      "value": "vswayscongcash"
  },
  {
      "label": "vs10jokerhot",
      "value": "vs10jokerhot"
  },
  {
      "label": "vs20cashmachine",
      "value": "vs20cashmachine"
  },
  {
      "label": "vs5hotburn",
      "value": "vs5hotburn"
  },
  {
      "label": "vs25jokrace",
      "value": "vs25jokrace"
  },
  {
      "label": "vs20vegasmagic",
      "value": "vs20vegasmagic"
  },
  {
      "label": "vs25goldpig",
      "value": "vs25goldpig"
  },
  {
      "label": "vs25bullfiesta",
      "value": "vs25bullfiesta"
  },
  {
      "label": "vs20hstgldngt",
      "value": "vs20hstgldngt"
  },
  {
      "label": "vs10egrich",
      "value": "vs10egrich"
  },
  {
      "label": "vswayseternity",
      "value": "vswayseternity"
  },
  {
      "label": "vs20honey",
      "value": "vs20honey"
  },
  {
      "label": "vs20ltng",
      "value": "vs20ltng"
  },
  {
      "label": "vs10bburger",
      "value": "vs10bburger"
  },
  {
      "label": "vs20sbpnudge",
      "value": "vs20sbpnudge"
  },
  {
      "label": "vs20colcashzone",
      "value": "vs20colcashzone"
  },
  {
      "label": "vs1024temuj",
      "value": "vs1024temuj"
  },
  {
      "label": "vs20earthquake",
      "value": "vs20earthquake"
  },
  {
      "label": "vs10bookazteck",
      "value": "vs10bookazteck"
  },
  {
      "label": "vs20irishcrown",
      "value": "vs20irishcrown"
  },
  {
      "label": "vs5spjoker",
      "value": "vs5spjoker"
  },
  {
      "label": "vswaysftropics",
      "value": "vswaysftropics"
  },
  {
      "label": "vswaysalterego",
      "value": "vswaysalterego"
  },
  {
      "label": "vs50jfmulthold",
      "value": "vs50jfmulthold"
  },
  {
      "label": "vs10threestar",
      "value": "vs10threestar"
  },
  {
      "label": "vs25kingdoms",
      "value": "vs25kingdoms"
  },
  {
      "label": "vswaysjkrdrop",
      "value": "vswaysjkrdrop"
  },
  {
      "label": "vs9madmonkey",
      "value": "vs9madmonkey"
  },
  {
      "label": "vs117649starz",
      "value": "vs117649starz"
  },
  {
      "label": "vs20stickypos",
      "value": "vs20stickypos"
  },
  {
      "label": "vs40voodoo",
      "value": "vs40voodoo"
  },
  {
      "label": "vs20gobnudge",
      "value": "vs20gobnudge"
  },
  {
      "label": "vs1024dtiger",
      "value": "vs1024dtiger"
  },
  {
      "label": "vs20underground",
      "value": "vs20underground"
  },
  {
      "label": "vs20beefed",
      "value": "vs20beefed"
  },
  {
      "label": "vs88hockattack",
      "value": "vs88hockattack"
  },
  {
      "label": "vs25lagoon",
      "value": "vs25lagoon"
  },
  {
      "label": "vswayshexhaus",
      "value": "vswayshexhaus"
  },
  {
      "label": "vs20daydead",
      "value": "vs20daydead"
  },
  {
      "label": "vs40pirgold",
      "value": "vs40pirgold"
  },
  {
      "label": "vs20clreacts",
      "value": "vs20clreacts"
  },
  {
      "label": "vs20devilic",
      "value": "vs20devilic"
  },
  {
      "label": "vs20smugcove",
      "value": "vs20smugcove"
  },
  {
      "label": "vs25goldrush",
      "value": "vs25goldrush"
  },
  {
      "label": "vs20treesot",
      "value": "vs20treesot"
  },
  {
      "label": "vs20chicken",
      "value": "vs20chicken"
  },
  {
      "label": "vs25spgldways",
      "value": "vs25spgldways"
  },
  {
      "label": "vs20mmmelon",
      "value": "vs20mmmelon"
  },
  {
      "label": "vs10mmm",
      "value": "vs10mmm"
  },
  {
      "label": "vs25davinci",
      "value": "vs25davinci"
  },
  {
      "label": "vs20mtreasure",
      "value": "vs20mtreasure"
  },
  {
      "label": "vs20rainbowg",
      "value": "vs20rainbowg"
  },
  {
      "label": "vs20lvlup",
      "value": "vs20lvlup"
  },
  {
      "label": "vs20ekingrr",
      "value": "vs20ekingrr"
  },
  {
      "label": "vs20stckwldsc",
      "value": "vs20stckwldsc"
  },
  {
      "label": "vs20egypttrs",
      "value": "vs20egypttrs"
  },
  {
      "label": "vs20forgewilds",
      "value": "vs20forgewilds"
  },
  {
      "label": "vs10hottb7fs",
      "value": "vs10hottb7fs"
  },
  {
      "label": "vs10goldfish",
      "value": "vs10goldfish"
  },
  {
      "label": "vs243nudge4gold",
      "value": "vs243nudge4gold"
  },
  {
      "label": "vs10crownfire",
      "value": "vs10crownfire"
  },
  {
      "label": "vs10mayangods",
      "value": "vs10mayangods"
  },
  {
      "label": "vs25spotz",
      "value": "vs25spotz"
  },
  {
      "label": "vs20hercpeg",
      "value": "vs20hercpeg"
  },
  {
      "label": "vs20lampinf",
      "value": "vs20lampinf"
  },
  {
      "label": "vs18mashang",
      "value": "vs18mashang"
  },
  {
      "label": "vswaysspltsym",
      "value": "vswaysspltsym"
  },
  {
      "label": "vs20theights",
      "value": "vs20theights"
  },
  {
      "label": "vs7pigs",
      "value": "vs7pigs"
  },
  {
      "label": "vs3train",
      "value": "vs3train"
  },
  {
      "label": "vs10egypt",
      "value": "vs10egypt"
  },
  {
      "label": "vs5gemstone",
      "value": "vs5gemstone"
  },
  {
      "label": "vs1ball",
      "value": "vs1ball"
  },
  {
      "label": "vs10dyndigd",
      "value": "vs10dyndigd"
  },
  {
      "label": "vs5drmystery",
      "value": "vs5drmystery"
  },
  {
      "label": "vswaysseastory",
      "value": "vswaysseastory"
  },
  {
      "label": "vs20elevclust",
      "value": "vs20elevclust"
  },
  {
      "label": "vs25newyear",
      "value": "vs25newyear"
  },
  {
      "label": "vs15fairytale",
      "value": "vs15fairytale"
  },
  {
      "label": "vs4096mystery",
      "value": "vs4096mystery"
  },
  {
      "label": "vs25journey",
      "value": "vs25journey"
  },
  {
      "label": "vswaysoldminer",
      "value": "vswaysoldminer"
  },
  {
      "label": "vs40madwheel",
      "value": "vs40madwheel"
  },
  {
      "label": "vs25dragonkingdom",
      "value": "vs25dragonkingdom"
  },
  {
      "label": "vs50dmdcascade",
      "value": "vs50dmdcascade"
  },
  {
      "label": "vs25walker",
      "value": "vs25walker"
  },
  {
      "label": "vs20piggybank",
      "value": "vs20piggybank"
  },
  {
      "label": "vswaysincwnd",
      "value": "vswaysincwnd"
  },
  {
      "label": "vs20loksriches",
      "value": "vs20loksriches"
  },
  {
      "label": "vs5hotbmult",
      "value": "vs5hotbmult"
  },
  {
      "label": "vs20wildboost",
      "value": "vs20wildboost"
  },
  {
      "label": "vs20wildpix",
      "value": "vs20wildpix"
  },
  {
      "label": "vs10jnmntzma",
      "value": "vs10jnmntzma"
  },
  {
      "label": "vswaysraghex",
      "value": "vswaysraghex"
  },
  {
      "label": "vs20leprexmas",
      "value": "vs20leprexmas"
  },
  {
      "label": "vs243discolady",
      "value": "vs243discolady"
  },
  {
      "label": "vs10ddcbells",
      "value": "vs10ddcbells"
  },
  {
      "label": "vs20eking",
      "value": "vs20eking"
  },
  {
      "label": "vs5trdragons",
      "value": "vs5trdragons"
  },
  {
      "label": "vs25samurai",
      "value": "vs25samurai"
  },
  {
      "label": "vs25xmasparty",
      "value": "vs25xmasparty"
  },
  {
      "label": "vs50northgard",
      "value": "vs50northgard"
  },
  {
      "label": "vs5strh",
      "value": "vs5strh"
  },
  {
      "label": "vswayswwhex",
      "value": "vswayswwhex"
  },
  {
      "label": "vs50chinesecharms",
      "value": "vs50chinesecharms"
  },
  {
      "label": "vs7776secrets",
      "value": "vs7776secrets"
  },
  {
      "label": "vs50pixie",
      "value": "vs50pixie"
  },
  {
      "label": "vs10kingofdth",
      "value": "vs10kingofdth"
  },
  {
      "label": "vs20sknights",
      "value": "vs20sknights"
  },
  {
      "label": "vs25jokerking",
      "value": "vs25jokerking"
  },
  {
      "label": "vs20jhunter",
      "value": "vs20jhunter"
  },
  {
      "label": "vs10vampwolf",
      "value": "vs10vampwolf"
  },
  {
      "label": "vs25tigerwar",
      "value": "vs25tigerwar"
  },
  {
      "label": "vs243ckemp",
      "value": "vs243ckemp"
  },
  {
      "label": "vs25safari",
      "value": "vs25safari"
  },
  {
      "label": "vs10snakeladd",
      "value": "vs10snakeladd"
  },
  {
      "label": "vs40demonpots",
      "value": "vs40demonpots"
  },
  {
      "label": "vswaystimber",
      "value": "vswaystimber"
  },
  {
      "label": "vs50kingkong",
      "value": "vs50kingkong"
  },
  {
      "label": "vs5firehot",
      "value": "vs5firehot"
  },
  {
      "label": "vs100firehot",
      "value": "vs100firehot"
  },
  {
      "label": "vs243koipond",
      "value": "vs243koipond"
  },
  {
      "label": "vs10luckfort",
      "value": "vs10luckfort"
  },
  {
      "label": "vs20aladdinsorc",
      "value": "vs20aladdinsorc"
  },
  {
      "label": "vs20lobseafd",
      "value": "vs20lobseafd"
  },
  {
      "label": "vs7monkeys",
      "value": "vs7monkeys"
  },
  {
      "label": "vs25sea",
      "value": "vs25sea"
  },
  {
      "label": "vswaysfrbugs",
      "value": "vswaysfrbugs"
  },
  {
      "label": "vs40streetracer",
      "value": "vs40streetracer"
  },
  {
      "label": "vs10starpirate",
      "value": "vs10starpirate"
  },
  {
      "label": "vs10chkchase",
      "value": "vs10chkchase"
  },
  {
      "label": "vs40hotburnx",
      "value": "vs40hotburnx"
  },
  {
      "label": "vs20santa",
      "value": "vs20santa"
  },
  {
      "label": "vs20mvwild",
      "value": "vs20mvwild"
  },
  {
      "label": "vs100sh",
      "value": "vs100sh"
  },
  {
      "label": "vs50hercules",
      "value": "vs50hercules"
  },
  {
      "label": "vs20hotzone",
      "value": "vs20hotzone"
  },
  {
      "label": "vs1fufufu",
      "value": "vs1fufufu"
  },
  {
      "label": "vs20wildman",
      "value": "vs20wildman"
  },
  {
      "label": "vs20lcount",
      "value": "vs20lcount"
  },
  {
      "label": "vswayscfglory",
      "value": "vswayscfglory"
  },
  {
      "label": "vswaysredqueen",
      "value": "vswaysredqueen"
  },
  {
      "label": "vs20gorilla",
      "value": "vs20gorilla"
  },
  {
      "label": "vs10snakeeyes",
      "value": "vs10snakeeyes"
  },
  {
      "label": "vswaysbankbonz",
      "value": "vswaysbankbonz"
  },
  {
      "label": "vs40frrainbow",
      "value": "vs40frrainbow"
  },
  {
      "label": "vs20lobcrab",
      "value": "vs20lobcrab"
  },
  {
      "label": "vs20godiva",
      "value": "vs20godiva"
  },
  {
      "label": "vs25dwarves_new",
      "value": "vs25dwarves_new"
  },
  {
      "label": "vs20bl",
      "value": "vs20bl"
  },
  {
      "label": "vs8magicjourn",
      "value": "vs8magicjourn"
  },
  {
      "label": "vs25gladiator",
      "value": "vs25gladiator"
  },
  {
      "label": "vs13g",
      "value": "vs13g"
  },
  {
      "label": "vs40sh",
      "value": "vs40sh"
  },
  {
      "label": "vs20fh",
      "value": "vs20fh"
  },
  {
      "label": "vs40firehot",
      "value": "vs40firehot"
  },
  {
      "label": "vs20sh",
      "value": "vs20sh"
  },
  {
      "label": "vs5sh",
      "value": "vs5sh"
  },
  {
      "label": "scwolfgoldai",
      "value": "scwolfgoldai"
  },
  {
      "label": "scgoldrushai",
      "value": "scgoldrushai"
  },
  {
      "label": "scdiamondai",
      "value": "scdiamondai"
  },
  {
      "label": "scqogai",
      "value": "scqogai"
  },
  {
      "label": "scpandai",
      "value": "scpandai"
  },
  {
      "label": "sc7piggiesai",
      "value": "sc7piggiesai"
  },
  {
      "label": "scsafariai",
      "value": "scsafariai"
  },
  {
      "label": "vsprg10bbbnza",
      "value": "vsprg10bbbnza"
  },
  {
      "label": "vsprg10bigbass",
      "value": "vsprg10bigbass"
  },
  {
      "label": "vsprg10booktut",
      "value": "vsprg10booktut"
  },
  {
      "label": "vs20mysteryst",
      "value": "vs20mysteryst"
  },
  {
      "label": "vsprg20fruitpty",
      "value": "vsprg20fruitpty"
  },
  {
      "label": "vsprg20olympus",
      "value": "vsprg20olympus"
  },
  {
      "label": "vs40mstrwild",
      "value": "vs40mstrwild"
  },
  {
      "label": "vsprg5joker",
      "value": "vsprg5joker"
  },
  {
      "label": "vsprg20starpr",
      "value": "vsprg20starpr"
  },
  {
      "label": "vsprg20sugarush",
      "value": "vsprg20sugarush"
  },
  {
      "label": "vsprg20fruitsw",
      "value": "vsprg20fruitsw"
  },
  {
      "label": "vsprg20doghouse",
      "value": "vsprg20doghouse"
  },
  {
      "label": "vsprgwaysdogs",
      "value": "vsprgwaysdogs"
  },
  {
      "label": "vs75bronco",
      "value": "vs75bronco"
  },
  {
      "label": "vs75empress",
      "value": "vs75empress"
  },
  {
      "label": "vs20buddhasgg",
      "value": "vs20buddhasgg"
  },
  {
      "label": "vs5barongrico",
      "value": "vs5barongrico"
  },
  {
      "label": "vs25queenofgold",
      "value": "vs25queenofgold"
  },
  {
      "label": "vs20powerpays",
      "value": "vs20powerpays"
  },
  {
      "label": "vs25kingdomsnojp",
      "value": "vs25kingdomsnojp"
  },
  {
      "label": "vs7monkeys_jp",
      "value": "vs7monkeys_jp"
  },
  {
      "label": "sc7piggies",
      "value": "sc7piggies"
  },
  {
      "label": "vs10bookviking",
      "value": "vs10bookviking"
  },
  {
      "label": "scdiamond",
      "value": "scdiamond"
  },
  {
      "label": "scgoldrush",
      "value": "scgoldrush"
  },
  {
      "label": "vs20hockey",
      "value": "vs20hockey"
  },
  {
      "label": "vs9hockey",
      "value": "vs9hockey"
  },
  {
      "label": "scsafari",
      "value": "scsafari"
  },
  {
      "label": "vs25champlg",
      "value": "vs25champlg"
  },
  {
      "label": "scpanda",
      "value": "scpanda"
  },
  {
      "label": "ar10plinko",
      "value": "ar10plinko"
  },
  {
      "label": "scqog",
      "value": "scqog"
  },
  {
      "label": "vs25romeoandjuliet",
      "value": "vs25romeoandjuliet"
  },
  {
      "label": "vs20cms",
      "value": "vs20cms"
  },
  {
      "label": "vs9catz",
      "value": "vs9catz"
  },
  {
      "label": "vs30catz",
      "value": "vs30catz"
  },
  {
      "label": "scwolfgold",
      "value": "scwolfgold"
  },
  {
      "label": "vs25wolfjpt",
      "value": "vs25wolfjpt"
  },
  {
      "label": "vs15eyeofspart",
      "value": "vs15eyeofspart"
  },
  {
      "label": "vs20gtsofhades",
      "value": "vs20gtsofhades"
  },
  {
      "label": "vswaysmwss",
      "value": "vswaysmwss"
  },
  {
      "label": "vs25goldrexp",
      "value": "vs25goldrexp"
  },
  {
      "label": "vs25pfarmfp",
      "value": "vs25pfarmfp"
  },
  {
      "label": "vs20wwgcluster",
      "value": "vs20wwgcluster"
  }
];

class DailyCheckInListRuleSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCard: true,
      vipLevels: [], // dropdown option map
      data: {},
      totalRecords: 0,
      activePage: 1,
      limit: 10,
      loading: false,
      searchInput: {
        vipLevel: 1,
      },
    };
  }

  rowNumberFormatter = (rowIndex) => {
    let rowNumber =
      (this.state.activePage - 1) * this.state.limit + rowIndex + 1;
    return <span>{rowNumber}</span>;
  };

  onEditRule = (e, t, ruleSetting) => {
    e.preventDefault();
    this.props.onChangeTabIdHandler(e, "UPDATE_RULE_SETTING", {
      ...ruleSetting,
      day: ruleSetting.day,
      vipLevel: t(
        `global.level.${this.props.currentUser?.merchant_slug}.${ruleSetting.vip_level}`
      ),
    });
  };

  onChangeVipLevel = (e) => {
    this.setState({
      ...this.state,
      searchInput: {
        ...this.state.searchInput,
        vipLevel: e.target.value,
      },
    });
  };

  onSearch = () => {
    this.setState(
      {
        ...this.state,
        loading: true,
      },
      () => {
        this.props.getDailyCheckInRuleSetting({
          page: this.state.activePage,
          limit: this.state.limit,
          order: "desc",
          sort: "created_at",
          vipLevel: this.state.searchInput.vipLevel,
        });
      }
    );
  };

  onReset = () => {
    this.setState(
      {
        ...this.state,
      },
      () => this.onSearch()
    );
  };

  onChangePage = (page) => {
    this.setState(
      {
        ...this.state,
        activePage: Number(page),
      },
      () => this.onSearch()
    );
  };

  onChangeLimit = (limit) => {
    this.setState(
      {
        ...this.state,
        limit: Number(limit),
      },
      () => this.onSearch()
    );
  };

  // e is an array of { label, value }
  onChangeGameCodes = (e) => {
    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        free_spin_game_codes: e || [],
      },
    });
  };

  onChangeFreeSpinDuration = (e) => {
    const { id, value } = e.target;

    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        free_spin_duration: value,
      },
    });
  };

  onChangeBetScale = (e) => {
    const { id, value } = e.target;

    const parts = id.split("-");

    const vipLevelIndex = parseInt(parts[0]);

    this.setState({
      ...this.state,
      data: {
        ...this.state.data,
        vip_levels: this.state.data.vip_levels.map(
          (vipLevel, vipLevelIndex1) => {
            if (vipLevelIndex === vipLevelIndex1) {
              return {
                ...vipLevel,
                bet_scale: value,
              };
            }
            return vipLevel;
          }
        ),
      },
    });
  };

  onChangeInput = (e) => {
    const { id, value } = e.target;

    const parts = id.split("-"); // have length of 3

    const vipLevelIndex = parseInt(parts[0]);
    const dayIndex = parseInt(parts[1]);
    const fieldName = parts[2];

    const updatedData = {
      ...this.state.data,
      vip_levels: this.state.data.vip_levels.map((vipLevel, vipLevelIndex1) => {
        if (vipLevelIndex === vipLevelIndex1) {
          return {
            ...vipLevel,
            days: vipLevel.days.map((day, dayIndex1) => {
              if (dayIndex === dayIndex1) {
                return {
                  ...day,
                  [fieldName]: value,
                };
              }
              return day;
            }),
          };
        }
        return vipLevel;
      }),
    };

    this.setState({
      ...this.state,
      data: updatedData,
    });
  };

  onSave = () => {
    // Show Swal loading bar when saving
    Swal.fire({
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    // server is expecting a list of gameCodes only (value), not { label, value }[]
    const freeSpinGameCodes = this.state.data.free_spin_game_codes.map(
      (item) => item.value
    );

    this.props.updateDailyCheckInRuleSetting({
      rule: {
        ...this.state.data,
        free_spin_game_codes: freeSpinGameCodes,
      },
    });
  };

  componentDidMount() {
    this.props.getMemberGroupDropDown();
    this.onSearch();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.listRuleSetting !== this.props.listRuleSetting &&
      this.props.listRuleSetting &&
      this.props.listRuleSetting.data &&
      this.props.listRuleSetting.data.responseCode === 200 &&
      this.props.listRuleSetting.data.data &&
      this.props.listRuleSetting.data.data.result
    ) {
      const result = this.props.listRuleSetting.data.data.result;

      const freeSpinGameCodes = result.free_spin_game_codes
        .map((gameCode) => {
          return gameCodeOptions.find((gc) => gc.value === gameCode);
        })
        .filter(Boolean); // filter out undefined

      this.setState({
        ...this.state,
        data: {
          ...result,
          free_spin_game_codes: freeSpinGameCodes,
        },
        loading: false,
      });
    }

    if (
      prevProps.memberGroup !== this.props.memberGroup &&
      this.props.memberGroup &&
      this.props.memberGroup.responseCode === 200 &&
      this.props.memberGroup.data &&
      this.props.memberGroup.data.member_group
    ) {
      this.setState({
        ...this.state,
        vipLevels: this.props.memberGroup.data.member_group.map(
          (memberGroup) => memberGroup.level
        ),
      });
    }

    if (
      prevProps.updateRuleSetting !== this.props.updateRuleSetting &&
      this.props.updateRuleSetting &&
      this.props.updateRuleSetting.data &&
      this.props.updateRuleSetting.data.responseCode === 200
    ) {
      Swal.fire({
        icon: "success",
        title: this.props.t("global.success"),
        text: this.props.t("global.success"),
        showConfirmButton: true,
      });
    }
  }

  render() {
    let { t } = this.props;

    return (
      <Auxiliary>
        <div className="row row-sm">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header pb-0">
                <div className="d-flex justify-content-between">
                  <h4 className="card-title mg-b-0">
                    {t("global.daily-check-in-list-rule-setting")}
                  </h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive table-hover datatable">
                  {this.state.loading ? (
                    <Skeleton count={10} />
                  ) : (
                    <div>
                      <div className="row pb-3">
                        <div className="col-3">
                          <label className="form-label">PP Game Codes:</label>
                          <Select2
                            id={`game_codes`}
                            name={`game_codes`}
                            className="form-control"
                            value={this.state.data.free_spin_game_codes}
                            onChange={this.onChangeGameCodes}
                            options={gameCodeOptions}
                            getOptionValue="value"
                            getOptionLabel="label"
                          />
                        </div>
                        <div className="col-3">
                          <label className="form-label">
                            PP Free Spin Duration (days):
                          </label>
                          <NumberInput
                            id={`free_spin_duration`}
                            name={`free_spin_duration`}
                            className="form-control"
                            value={this.state.data.free_spin_duration}
                            onChange={this.onChangeFreeSpinDuration}
                            min={0}
                            placeholder="3"
                          />
                        </div>
                      </div>
                      {this.state.data?.vip_levels?.map(
                        (vipLevel, vipLevelIndex) => {
                          return (
                            <div key={vipLevelIndex}>
                              <h1>{t(`global.level.${this.props.currentUser?.merchant_slug}.${vipLevelIndex + 1}`)}</h1>
                              <div className="row pb-3">
                                <div className="col-2">
                                  <label className="form-label">
                                    PP Bet Scale:
                                  </label>
                                  <NumberInput
                                    id={`${vipLevelIndex}-bet_scale`}
                                    name={`${vipLevelIndex}-bet_scale`}
                                    className="form-control"
                                    value={vipLevel.bet_scale}
                                    onChange={this.onChangeBetScale}
                                    min={0}
                                    placeholder="0.01"
                                  />
                                </div>
                              </div>
                              {vipLevel.days.map((day, dayIndex) => {
                                return (
                                  <div
                                    key={dayIndex}
                                    className="py-3 border-bottom mb-3"
                                  >
                                    <span>Day {dayIndex + 1}</span>
                                    <div className="row pb-3">
                                      <div className="col-2">
                                        <label className="form-label">
                                          PP Reward Total Free Spin:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-reward_total_free_spin`}
                                          name={`${vipLevelIndex}-${dayIndex}-reward_total_free_spin`}
                                          className="form-control"
                                          value={day.reward_total_free_spin}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                      <div className="col-2">
                                        <label className="form-label">
                                          Reward Credit:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-reward_credit`}
                                          name={`${vipLevelIndex}-${dayIndex}-reward_credit`}
                                          className="form-control"
                                          value={day.reward_credit}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                      <div className="col-2">
                                        <label className="form-label">
                                          Reward Coin:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-reward_coin`}
                                          name={`${vipLevelIndex}-${dayIndex}-reward_coin`}
                                          className="form-control"
                                          value={day.reward_coin}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                      <div className="col-2">
                                        <label className="form-label">
                                          Required Deposit:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-required_deposit`}
                                          name={`${vipLevelIndex}-${dayIndex}-required_deposit`}
                                          className="form-control"
                                          value={day.required_deposit}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                      <div className="col-2">
                                        <label className="form-label">
                                          Turnover Multiplier:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-turnover_multiplier`}
                                          name={`${vipLevelIndex}-${dayIndex}-turnover_multiplier`}
                                          className="form-control"
                                          value={day.turnover_multiplier}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                    </div>
                                    <div className="row pb-3">
                                      <div className="col-2">
                                        <label className="form-label">
                                          PP Extra Total Free Spin:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-extra_reward_total_free_spin`}
                                          name={`${vipLevelIndex}-${dayIndex}-extra_reward_total_free_spin`}
                                          className="form-control"
                                          value={
                                            day.extra_reward_total_free_spin
                                          }
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                      <div className="col-2">
                                        <label className="form-label">
                                          Extra Credit:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-extra_reward_credit`}
                                          name={`${vipLevelIndex}-${dayIndex}-extra_reward_credit`}
                                          className="form-control"
                                          value={day.extra_reward_credit}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                      <div className="col-2">
                                        <label className="form-label">
                                          Extra Coin:
                                        </label>
                                        <NumberInput
                                          id={`${vipLevelIndex}-${dayIndex}-extra_reward_coin`}
                                          name={`${vipLevelIndex}-${dayIndex}-extra_reward_coin`}
                                          className="form-control"
                                          value={day.extra_reward_coin}
                                          onChange={this.onChangeInput}
                                          min={0}
                                          placeholder="0"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          );
                        }
                      )}

                      <div className="d-flex justify-content-center">
                        <Button
                          typeButton="button"
                          classValue="btn btn-blue"
                          idValue="filter"
                          buttonName={t("global.save")}
                          clicked={() => this.onSave()}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Auxiliary>
    );
  }
}

const mapStateToProps = (reduxState) => {
  return {
    currentUser: reduxState.currentUser.data,
    memberGroup: reduxState.memberGroup?.dropDown,
    listRuleSetting: reduxState.dailyCheckIn?.listRuleSetting,
    updateRuleSetting: reduxState.dailyCheckIn?.updateRuleSetting,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getMemberGroupDropDown: (data) => dispatch(getDropDown(data)),
    getDailyCheckInRuleSetting: (data) =>
      dispatch(getDailyCheckInRuleSetting(data)),
    updateDailyCheckInRuleSetting: (data) =>
      dispatch(updateDailyCheckInRuleSetting(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withNamespaces("translation")(DailyCheckInListRuleSetting));
